import { useState } from 'react';

import { IconButton } from '@/components';
import { CopyIcon } from '@/components/Icons';

import { R } from '../../resources/Texts.resx';

type CopyButtonProps = {
    onClick: () => void;
};

export const CopyButton = ({ onClick }: CopyButtonProps) => {
    const [copied, setCopied] = useState(false);
    const handleCopy = () => {
        setCopied(true);
        onClick();
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <IconButton
            tooltip={copied ? R.Copied : R.Copy}
            onClick={handleCopy}
            className="active:bg-(--color-icon-action-bg-pressed)"
            icon={<CopyIcon variant="action" />}
        />
    );
};
